import { ISocketLogger } from "geotab-web-sockets";
import { IApiError } from "./api.interfaces";
import * as logger from "./logger";

export default class WebSocketLogger implements ISocketLogger {
    private readonly user: string;
    private readonly loggerCategory;

    constructor(loggerCategory: logger.Source, user: string) {
        this.user = user;
        this.loggerCategory = loggerCategory;
    }

    log(message: string): void {
        logger.log(this.loggerCategory, message, this.user);
    }
    warn(message: string): void {
        logger.log(this.loggerCategory, `WARN ${ message }`, this.user);
    }
    error(message: string, errorObject?: IApiError): void {
        logger.error(this.loggerCategory, message, this.user, errorObject);
    }
}
